import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Base_url } from "../config";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";

let Login = () => {

    let [username, setUsername] = useState("");
    let [password, setPassword] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        Check()
    }, []);

    let Check = async () => {
        let token = await localStorage.getItem('token');
        if (token === undefined || token === null || token === '') {

        } else {

            let token = await localStorage.getItem("token");
            let pp = { token };
            let data = await AesEncrypt(pp);

            let apicall = await axios({
                method: "post",
                url: Base_url + "/admin/counts",
                data: {
                    data: data,
                },
            })
                .then((re) => {
                    let parsedata = AesDecrypt(re.data);
                    let Jsson = JSON.parse(parsedata);
                    if (Jsson.status === true) { 
                        navigate("/"); 
                    } else {
                        // navigate("/login");
                        console.log(Jsson, 'llll')
                    }

                })
                .catch((err) => {
                    console.log(err, 'jjjj')
                })

            // navigate('/')
        }
    }

    let submit = async () => {
        if (username === '' || password === '') {
            // alert('please enter username and password')
            return
        }
        try {

            let pp = { username: username, password: password }
            let data = await AesEncrypt(pp)
            // console.log(AES , 'AES')
            // let AesDe = await AesDecrypt(AES)
            // console.log(AesDe , 'AesDe')

            let apicall = await axios({
                method: 'post',
                url: Base_url + '/admin/adminlogin',
                data: {
                    data: data
                }
            })
                .then((dat) => {
                    console.log(dat.data, 'Jsson')
                    let parsedata = AesDecrypt(dat.data)
                    let Jsson = JSON.parse(parsedata)
                    console.log(Jsson, 'Jsson')
                    if (Jsson.status === true) {
                        localStorage.setItem('token', Jsson.token)
                        navigate('/')
                    } else {
                        alert(Jsson.message)
                    }
                })
                .catch((ee) => {
                })


        } catch (err) {
        }
    }

    return (
        <section className="vh-100" style={{ backgroundColor: "#9A616D" }}>
            <div className="container py-5 h-100">
                <div className="row d-flex justify-content-center align-items-center h-100">
                    <div className="col col-xl-10">
                        <div className="card" style={{ borderRadius: "1rem" }}>
                            <div className="row g-0">
                                <div className="col-md-6 col-lg-5 d-none d-md-block">
                                    <img
                                        src="https://mdbootstrap.com/img/new/ecommerce/vertical/004.jpg"
                                        alt="Trendy Pants and Shoes"
                                        className="img-fluid"
                                        style={{ borderRadius: "1rem 0 0 1rem" }}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-7 d-flex align-items-center">
                                    <div className="card-body p-4 p-lg-5 text-black">
                                        <form>
                                            <div className="d-flex align-items-center mb-3 pb-1">
                                                <i
                                                    className="fas fa-cubes fa-2x me-3"
                                                    style={{ color: " #ff6219" }}
                                                ></i>
                                                <span className="h1 fw-bold mb-0">Logo</span>
                                            </div>

                                            <h5
                                                className="fw-normal mb-3 pb-3"
                                                style={{ letterSpacing: 1 }}
                                            >
                                                Sign into your account
                                            </h5>

                                            <p>User Name</p>
                                            <div className="form-outline mb-4">
                                                <input
                                                    type="email"
                                                    id="form2Example17"
                                                    placeholder="phone no"
                                                    style={{ background: '#c5c5c588' }}
                                                    className="form-control form-control-lg"
                                                    onChange={(e) => {
                                                        setUsername(e.target.value)
                                                    }}
                                                />
                                            </div>

                                            <p>Password</p>

                                            <div className="form-outline mb-4">
                                                <input
                                                    type="password"

                                                    className="form-control form-control-lg"
                                                    id="form2Example27"
                                                    placeholder="password"
                                                    style={{ background: '#c5c5c588' }}
                                                    onChange={(e) => {
                                                        setPassword(e.target.value)
                                                    }}
                                                />

                                            </div>

                                            <div className="pt-1 mb-4">
                                                <button
                                                    className="btn btn-dark btn-lg btn-block"
                                                    type="button"
                                                    onClick={() => { submit() }}
                                                >
                                                    Login
                                                </button>
                                            </div>

                                            <a className="small text-muted" href="#!">
                                                Forgot password?
                                            </a>
                                            <p className="mb-5 pb-lg-2" style={{ color: "#393f81" }}>
                                                Don't have an account?{" "}
                                                <a href="#!" style={{ color: "#393f81" }}>
                                                    Register here
                                                </a>
                                            </p>
                                            <a href="#!" className="small text-muted">
                                                Terms of use.
                                            </a>
                                            <a href="#!" className="small text-muted">
                                                Privacy policy
                                            </a>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Login;
